import { defineComponent as _defineComponent } from 'vue'
import ProviderIcon from '@/components/picture/ProviderIcon.vue';
import { ModalHelper } from '@/helpers/vfm/modal-helper';
import { computed } from 'vue';
import { StreamingChartTitle } from './types';
import { useUserStore } from '@/stores/pinia/useUserStore';

interface OffersDisplayProps {
	title: StreamingChartTitle;
	isMobile?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OffersDisplay',
  props: {
    title: null,
    isMobile: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { title: StreamingChartTitle, isMobile: boolean };

const { setBuyboxPresentationType } = useUserStore();



const offers = computed(() => props.title.node.offers ?? []);
const cinemaOfferCount = computed(() => offers.value.filter(offer => offer.monetizationType === 'CINEMA').length);
const hasCinemaOffers = computed(() => cinemaOfferCount.value > 0);

const uniqueOffers = computed(() => [
	...new Map(
		offers.value.filter(offer => offer.monetizationType !== 'CINEMA').map(offer => [offer.package.packageId, offer])
	).values(),
]);
const visibleProvidersCount = computed(() => (props.isMobile ? 6 : 3));

const displayedOffers = computed(() => uniqueOffers.value.slice(0, visibleProvidersCount.value));

const displayMoreOffers = computed(() => {
	return (
		uniqueOffers.value.length - visibleProvidersCount.value > 0 ||
		(hasCinemaOffers.value && cinemaOfferCount.value > 0)
	);
});
const moreOffersCount = computed(() => {
	return hasCinemaOffers.value && uniqueOffers.value.length - visibleProvidersCount.value <= 0
		? cinemaOfferCount.value
		: uniqueOffers.value.length -
				visibleProvidersCount.value +
				(hasCinemaOffers.value ? cinemaOfferCount.value : 0);
});

async function openBuyboxModal() {
	const { default: WatchNowModal } = await import('@/components/modals/WatchNowModal.vue');
	setBuyboxPresentationType({ presentationType: null });
	ModalHelper.openModal(WatchNowModal, {
		title: props.title.node,
	});
}

return { __sfc: true,setBuyboxPresentationType, props, offers, cinemaOfferCount, hasCinemaOffers, uniqueOffers, visibleProvidersCount, displayedOffers, displayMoreOffers, moreOffersCount, openBuyboxModal, ProviderIcon }
}

})